import CustomerList from "./CustomerList.vue";
import CustomerListDetail from "./CustomerListDetail.vue";
import CustomerListInvoiceForm from "./CustomerListInvoiceForm.vue";

let routesCustomerList = [
  {
    path: "",
    meta: {
      title: "Chain System",
    },
    name: "CustomerList",
    component: CustomerList,
  },
  {
    path: "detail/:id",
    meta: {
      title: "Chain System",
    },
    name: "CustomerListDetail",
    component: CustomerListDetail,
  },
  {
    path: "detail/:id/create",
    meta: {
      title: "Chain System",
    },
    name: "CustomerListInvoiceCreate",
    component: CustomerListInvoiceForm,
  },
  {
    path: "detail/:id/edit/:piNo",
    meta: {
      title: "Chain System",
    },
    name: "CustomerListInvoiceEdit",
    component: CustomerListInvoiceForm,
  },
  {
    path: "detail/:id/view/:piNo",
    meta: {
      title: "Chain System",
    },
    name: "CustomerListInvoiceView",
    component: CustomerListInvoiceForm,
  },
];

export default routesCustomerList;
